const DEPARTMENT = {
  ADD_NEW_TEAM_BTN: 'Add new team',
  HEADER_TITLE: 'Add teams',
  EMPTY_TEAMS_LIST: 'You have not yet created any teams',
  TEAM_SELECT_DESCRIPTION: 'To set teams, choose your website',
  DELETE_DEFAULT_TEAM_ERROR: "It's not possible to delete default team",
  DEFAULT_TEAM_TOOLTIP:
    "By selecting start message, visitor's messages will be sent to this team",
  DEFAULT_TEAM_BADGE: 'Default team',
  OPERATOR_COUNT_TEXT: 'Operators',
  EDIT_MODAL_TITLE: 'Edit team',
  DELETE_MODAL_TITLE: 'Delete team',
  EMPTY_TEAM_ERROR: "Team's name can't be empty",
  EMPTY_OPERATORS_LIST: "Operator's list can't be empty",
  SUBMIT_TEXT: 'Submit',
  NO_OPERATOR_YET: 'No operator added yet',
  ENTER_TEAM_NAME: "Enter team's name",
  UPLOAD_LOGO: 'Upload logo',
  OPERATORS_HEADER_TITLE: 'Operators',
  REMOVE_IMAGE_BTN_TEXT: 'Remove image',
  SEARCH_OPERATOR_PLACEHOLDER: 'Add your operators to this team',
  SEARCH_RESULT_NO_OPERATOR: 'No operator found!',
  SEARCH_OPERATOR_RESULT_ADD_BTN: 'Add',
  SEARCH_OPERATOR_RESULT_REMOVE_BTN: 'Remove',
  REMOVE_OPERATOR_BTN_LABEL: 'Remove',
  ADD_TEAM_MODAL_HEADER_TITLE: 'Create new team',
  REMOVE_TEAM_MODAL_TITLE: 'Are you sure to remove this team?',
  ADD_TEAM_DESC:
    'With the "Create Teams" feature, you can create different teams with different expertise and assign a dedicated operator to each team. For example, you can set up a team for technical issues or have a finance team.',
  ERROR_MESSAGE: 'Filling in all fields is mandatory!',
  NAME_ERROR_MESSAGE: 'Entering the team name is essential!',
  MEMBER_ERROR_MESSAGE:
    'Selecting at least one member for the team is essential!',
};

export default DEPARTMENT;
